import request from '@/utils/request'
// 是否启用
export function enableProductCategory(data) {
  return request({
    url: '/power/goods/productCategory/enable',
    method: 'post',
    data: data,
  })
}
// 新增类目
export function categoryAdd(data) {
  return request({
    url: '/power/goods/productCategory/add',
    method: 'post',
    data: data,
  })
}

//修改商品类目
export function categoryEdit(data) {
  return request({
    url: '/power/goods/productCategory/edit',
    method: 'post',
    data: data,
  })
}

//查询商品类目详情
export function categoryDetail(query) {
  return request({
    url: '/power/goods/productCategory/detail',
    method: 'get',
    params: query,
  })
}

//查询货品类目列表
export function categoryList(query) {
  return request({
    url: '/power/goods/productCategory/list',
    method: 'get',
    params: query,
  })
}

// 查询货品类目列表（排除节点）
export function listCategoryExcludeChild(query) {
  return request({
    url: '/power/goods/productCategory/list/excludeChild',
    method: 'get',
    params: query,
  })
}

// 分类树
export function productCategoryTreeList(data) {
  return request({
    url: '/power/goods/productCategory/treeList',
    method: 'post',
    data,
  })
}
